
export const getStatusColor = (status: string) => {
  switch (status) {
    case 'Emerging Star':
      return 'bg-gradient-to-r from-purple-500 to-blue-500';
    case 'Gaining Momentum':
      return 'bg-gradient-to-r from-blue-500 to-cyan-500';
    case 'Breakthrough Artist':
      return 'bg-gradient-to-r from-amber-500 to-pink-500';
    case 'Established Act':
      return 'bg-gradient-to-r from-pink-500 to-purple-500';
    default:
      return 'bg-gradient-to-r from-gray-500 to-slate-500';
  }
};

export const getGrowthIndicator = (value: number) => {
  if (value > 0) {
    return { positive: true, icon: 'trending-up', color: 'text-emerald-500' };
  } else if (value < 0) {
    return { positive: false, icon: 'trending-down', color: 'text-rose-500' };
  }
  return { positive: true, icon: 'neutral', color: 'text-gray-500' };
};

export const formatGrowth = (value: number) => {
  if (value > 0) {
    return `+${value}%`;
  } else if (value < 0) {
    return `${value}%`;
  }
  return '0%';
};
